module.exports = __webpack_public_path__ + "img/productBgImg10.77bb9516.png";